import React from 'react'
import PropTypes from 'prop-types'

import I18n from 'lib/i18n'

import ReviewsBadge from './reviews-badge'

const DesktopReviews = ({ reviews }) => {
  return (
    <div className='four columns mobile-hide'>
      <h1 className='header'>{I18n.t('layouts.footer.reviews_title', { domain: reviews.domain })}</h1>
      <ReviewsBadge reviews={reviews} />
    </div>
  )
}

DesktopReviews.propTypes = {
  reviews: PropTypes.object
}

export default DesktopReviews
